export default {
  GET_BLOCKLIST_REQUEST: "GET_BLOCKLIST_REQUEST",
  GET_BLOCKLIST_RESPONSE: "GET_BLOCKLIST_RESPONSE",

  POST_BLOCKLIST_REQUEST: "POST_BLOCKLIST_REQUEST",
  POST_BLOCKLIST_RESPONSE: "POST_BLOCKLIST_RESPONSE",
  POST_BLOCKLIST_RESPONSE_CLEAR: "POST_BLOCKLIST_RESPONSE_CLEAR",

  DELETE_BLOCKLIST_REQUEST: "DELETE_BLOCKLIST_REQUEST",
  DELETE_BLOCKLIST_RESPONSE: "DELETE_BLOCKLIST_RESPONSE",
  DELETE_BLOCKLIST_RESPONSE_CLEAR: "DELETE_BLOCKLIST_RESPONSE_CLEAR",
};
